import * as React from 'react';
import { Pill } from '../Pill';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

// Enums
import { LOGIC_SET_STATUS } from '../../common/enums/logicSetStatuses';

const StatusPillEl = styled(Pill)`
    ${({ status }) => {
        if (status === LOGIC_SET_STATUS.INACTIVE) {
            return css`
                background: #6885ee;
                border-color: #6885ee;
                color: #fff;
            `;
        } else if (status === LOGIC_SET_STATUS.NOT_IMPLEMENTED) {
            return css`
                background: #7c7779;
                border-color: #7c7779;
                color: #fff;
            `;
        } else if (status === LOGIC_SET_STATUS.IMPLEMENTED) {
            return css`
                background: #0088cc;
                border-color: #0088cc;
                color: #fff;
            `;
        } else if (status === LOGIC_SET_STATUS.INOPERABLE) {
            return css`
                background: #ef8d3d;
                border-color: #ef8d3d;
                color: #fff;
            `;
        }
    }}
`;

const STATUS_LABELS = {
    [LOGIC_SET_STATUS.INACTIVE]: 'Inactive',
    [LOGIC_SET_STATUS.NOT_IMPLEMENTED]: 'Not Implemented',
    [LOGIC_SET_STATUS.IMPLEMENTED]: 'Implemented',
    [LOGIC_SET_STATUS.INOPERABLE]: 'Inoperable'
};

export const StatusPill = ({ status, ...props }) => {
    return (
        <StatusPillEl status={status} {...props}>
            {STATUS_LABELS[status]}
        </StatusPillEl>
    );
};

StatusPill.propTypes = {
    status: PropTypes.string
};

StatusPill.defaultProps = {
    status: ''
};
